import { Box } from '@mui/material';
import AIAssistedCreationWizard from 'AIAssistedCreationWizard';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import FundOpportunity from '../../models/FundOpportunity';

const AIWizardPage: React.FC<{ fundOpportunity: FundOpportunity }> = ({ fundOpportunity }) => {
  const navigate = useNavigate();

  const handleNavigateToContent = () => {
    navigate(`/opportunities/${fundOpportunity.id}/content`);
  };

  const handleExit = () => {
    navigate(`/opportunities/${fundOpportunity.id}`);
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <AIAssistedCreationWizard
        open={true}
        fundOpportunity={fundOpportunity}
        onNavigateToContent={handleNavigateToContent}
        onExit={handleExit}
        standalone={true}
      />
    </Box>
  );
};

export default AIWizardPage;
